module.exports = __webpack_public_path__ + "img/252-mexico.0aa67f12.svg";